// ---------------------------------------------------------------------------------------------
// Tasks
// ---------------------------------------------------------------------------------------------
export const TASK_LIST_VIEW = {
    MY: 'my',
    /** Assigned, but the scheduled start is still ahead — work that is coming, not work to do now. */
    UPCOMING: 'upcoming',
    BY_ME: 'by-me',
    TEAM: 'team',
    TODAY: 'today',
    OVERDUE: 'overdue',
    REVIEW: 'review',
    DONE: 'done',
    ALL: 'all',
    /** Learning work for interns. Separate from the ordinary task board. */
    INTERN: 'intern',
};
/** Actions on the task detail screen; the API decides which are enabled for the caller. */
export const TASK_ACTION = {
    ASSIGN: 'assign',
    START: 'start',
    BLOCK: 'block',
    UNBLOCK: 'unblock',
    SUBMIT: 'submit',
    APPROVE: 'approve',
    REJECT: 'reject',
    REOPEN: 'reopen',
    CANCEL: 'cancel',
    EDIT: 'edit',
    LOG_WORK: 'log-work',
};
//# sourceMappingURL=work.js.map